import { useReactionsResults as useCoreReactionsResults } from '@mentimeter/core-hooks';
import { useActiveSlideDeckPublicKey } from '@mentimeter/core-hooks/use-ids';
import { POLLING_INTERVAL } from '@mentimeter/editor-data-hooks';
import type { ReactionsResults } from '@mentimeter/http-clients';
import { usePresentationRealtimeStore } from '@mentimeter/realtime';

interface Reactions {
  data: ReactionsResults | undefined;
}

/**
 *
 * @deprecated This hook uses the legacy http-client, which will be removed in the future.
 * However, the new `usePresentationReactionResultsCompatibility` hook, which is meant to
 * replace this one, is unstable.
 */
export const useReactionsResults = (questionId?: string): Reactions => {
  const seriesId = useActiveSlideDeckPublicKey();
  const connectionState = usePresentationRealtimeStore(
    (state) => state.connectionState,
  );

  const { data } = useCoreReactionsResults(seriesId, questionId, {
    refreshInterval:
      connectionState === 'failed' || connectionState === 'disconnected'
        ? POLLING_INTERVAL
        : 0,
  });

  return {
    data,
  };
};
